import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Modal } from 'react-bootstrap';
import '../stylesheets/Organization.scss';
import Navbar from '../components/Navbar';
import ForwardArrow from '../Assets/forward-arrow.svg';
import { Link } from 'react-router-dom';
import Close from '../Assets/close.svg';
import ConsoleLocalStorage from '../storage/storage';
import { useHistory } from 'react-router';
import { orgStatus } from '../util/helpers/statusHelper';

const Login = () => {
    const [button, setButton] = useState(false);

    const history = useHistory();
    useEffect(() => {
        let orgData=ConsoleLocalStorage.getOrganization();
    if(!orgData){
      history.push("/login");
    }
    // else if(orgData && Object.keys(orgData).length ===0){
    //   setTimeout(() => history.push("/organization"), 10);
    // }
    else if(orgData.status === orgStatus.approved.status){
      setTimeout(() => history.push("/console"), 10);
    }else if(orgData.status === orgStatus.approved.status || orgData.status === orgStatus.draft.status){
      setTimeout(() => history.push("/create"), 10);
    }
    }, )
    const navigate = () => {
        if (button) history.push('/join-organization');
        else history.push('/create');
    };

    const handleClose=()=>{
    }

    const logout=()=>{
        ConsoleLocalStorage.clearStorageExceptFTU();


    }
    return (
        <React.Fragment>
            <Navbar showSignup={false} />
            <Container fluid className="main-container">
                <Modal show={true} centered contentClassName="login-modal p-2" onHide={handleClose}>
                    <Modal.Body className="pb-02">
                        <Container>
                            <Row>
                                <Col xs={10} md={11} className="px-0">
                                    <h4 style={{ color: '#FFFFFF' }}>
                                        All set! How would you like to continue?
                                    </h4>
                                </Col>
                                <Col xs={2} md={1} className="px-0 ">
                                    <span className="float-right">
                                        <Link to="/" onClick={()=>logout()}>
                                            <img
                                                src={Close}
                                                height="14"
                                                width="14"
                                                alt="cross"
                                            />
                                        </Link>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} className="px-0">
                                    <div className="flexbox">
                                        <div
                                            onClick={(e) => setButton(false)}
                                            className={
                                                !button
                                                    ? 'main focus buttonselected'
                                                    : 'main focus '
                                            }
                                        >
                                            <h3 className="boxname">
                                                Create Organization
                                            </h3>
                                        </div>

                                        <div
                                            onClick={(e) => setButton(true)}
                                            className={
                                                button
                                                    ? 'side focus buttonselected'
                                                    : 'side focus'
                                            }
                                        >
                                            <h3 className="boxname1">
                                                Join Organization
                                            </h3>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Col
                        xs={9}
                        md={{ span: 4, offset: 10 }}
                        style={{ backgroundColor: '#1D1D1' }}
                    >
                        <p className="sub-title next">
                            <span>
                                <span
                                    style={{
                                        color: '#77BAFF',
                                        marginTop: '20px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={(e) => navigate()}
                                >
                                    <span>
                                        {'Next '}
                                        <img
                                            alt=""
                                            src={ForwardArrow}
                                            height="12"
                                            width="13"
                                          
                                        />
                                    </span>{' '}
                                </span>
                            </span>
                        </p>
                    </Col>
                </Modal>
            </Container>
        </React.Fragment>
    );
};

export default Login;
